/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import Imgix from 'js/components/Imgix';

import { Grid, Link, Typography, Typography2 } from '@coursera/cds-core';

import type { Maybe } from 'bundles/xddp/__generated__/baseContentfulTypes';
import type { MarketingContentFieldsFragment } from 'bundles/xddp/__generated__/contentfulTypes';
import Container from 'bundles/xddp/components/shared/Container';

import 'css!bundles/xddp/components/__styles__/homepage/AboutProgram';

type Props = {
  header?: Maybe<string>;
  marketingContentList?: Array<Maybe<MarketingContentFieldsFragment>>;
};

const styles = {
  flexColumn: css`
    flex-direction: column;
  `,
  boldText: css`
    font-weight: bold;
  `,
};

const renderMarketingContent = (content: Maybe<MarketingContentFieldsFragment>) => {
  if (!content) {
    return null;
  }

  return (
    <Grid item key={content.title} className="about-program-card" sm={6} md={4}>
      {content.visual && content.visual.url && (
        <Imgix
          className="content-banner"
          src={content.visual.url}
          alt={content.visualAlternativeText ? content.visualAlternativeText : ''}
        />
      )}
      <Typography2 component="h3" className="content-title" variant="subtitleMedium">
        {content.title}
      </Typography2>
      <Typography2 component="p" className="content-description" variant="bodyPrimary">
        {content.description}
      </Typography2>
      {content.callToActionLink && (
        <Link
          className="page-link"
          css={styles.boldText}
          href={content.callToActionLink}
          typographyVariant="bodyPrimary"
        >
          {content.callToActionLabel}
        </Link>
      )}
    </Grid>
  );
};

const AboutProgram = ({ marketingContentList, header }: Props) => {
  if (!marketingContentList || !marketingContentList.length) {
    return null;
  }

  const sectionHeader = header || 'About the Program';

  return (
    <div className="rc-AboutProgram rc-CenteredHeaderSection">
      <Container>
        <Grid css={styles.flexColumn}>
          {/* eslint-disable-next-line @coursera-web/custom-rules/prefer-cds-typography2 -- FIXME: legacy; migrate to Typography2 */}
          <Typography className="section-header-center" variant="h2">
            {sectionHeader}
          </Typography>
          <Grid container spacing={24}>
            {marketingContentList.map(renderMarketingContent)}
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default AboutProgram;
